// Spots likely typos in an email's domain (icloud.con, gmial.com, hotmail.co) and suggests the fix.
const DOMAINS = [
  "gmail.com", "googlemail.com", "yahoo.com", "ymail.com", "hotmail.com", "outlook.com", "live.com", "msn.com",
  "icloud.com", "me.com", "mac.com", "aol.com", "mail.com", "gmx.com", "zoho.com", "protonmail.com", "proton.me",
  "comcast.net", "att.net", "sbcglobal.net", "verizon.net", "cox.net", "bellsouth.net", "charter.net",
  "yahoo.co.uk", "hotmail.co.uk",
];
const TLD_FIX = {
  con: "com", cmo: "com", ocm: "com", vom: "com", xom: "com", cpm: "com", cim: "com", comm: "com", coom: "com", c0m: "com",
  nte: "net", ner: "net", nett: "net", ent: "net", ogr: "org", orgg: "org", prg: "org", rog: "org",
};

function distance(a, b) {
  const row = Array.from({ length: b.length + 1 }, (_, i) => i);
  for (let i = 1; i <= a.length; i += 1) {
    let prev = row[0];
    row[0] = i;
    for (let j = 1; j <= b.length; j += 1) {
      const tmp = row[j];
      row[j] = Math.min(row[j] + 1, row[j - 1] + 1, prev + (a[i - 1] === b[j - 1] ? 0 : 1));
      prev = tmp;
    }
  }
  return row[b.length];
}

function closestKnown(domain) {
  let best = null;
  let bestD = 3;
  DOMAINS.forEach((d) => {
    const dist = distance(domain, d);
    if (dist < bestD) {
      best = d;
      bestD = dist;
    }
  });
  if (!best || bestD === 0) {
    return null;
  }
  return bestD === 1 || domain.length >= 8 ? best : null;
}

// The corrected address, or null when the address looks fine (or isn't an address yet).
export function suggestEmail(email) {
  const m = /^([^@\s]+)@([^@\s]+)$/.exec((email || "").trim());
  if (!m) {
    return null;
  }
  const domain = m[2].toLowerCase();
  if (DOMAINS.includes(domain)) {
    return null;
  }
  const parts = domain.split(".");
  const tld = parts[parts.length - 1];
  const fixed = parts.length > 1 && TLD_FIX[tld] ? [...parts.slice(0, -1), TLD_FIX[tld]].join(".") : domain;
  const better = DOMAINS.includes(fixed) ? fixed : closestKnown(fixed) || fixed;
  return better === domain ? null : `${m[1]}@${better}`;
}

// True until the address is fixed or the admin confirms the typed one is right.
export const needsTypoConfirm = (email, confirmed) => !!suggestEmail(email) && confirmed !== (email || "").trim();
